module.exports = "<uch></uch>\r\n<work-header params=\"current:'appApply'\"></work-header>\r\n<div class=\"work_content\">\r\n    <div class=\"userContent\">\r\n        <app-lication></app-lication>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/workflow/applicationIndex.html
// module id = 198
// module chunks = 0